export default {
  'default': {
    'title': 'Error',
    'message': 'An error has occurred'
  },
  '6': {
    'message': 'Wrong combination of email / password'
  },
  '10': {
    'message': 'Incomplete form'
  },
  '12': {
    'message': 'parameters incompatibility'
  },
  '21': {
    'message': 'Your password reset link expired'
  },
  '22': {
    'message': 'User already exists'
  },
  '25': {
    'message': 'User doesn\'t exist'
  },
  '29': {
    'message': 'The password must be at least 8 characters'
  },
  '43': {
    'message': 'The name of the campaign is already used. Please use another name for the campaign.'
  },
  '146': {
    'message': 'Cannot delete libray because it contains media'
  },
  '701': {
    'message': 'A challenge is already scheduled during this period.'
  }
}



// WEBPACK FOOTER //
// ./src/translations/en/api.js